var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-time"},[_c('b-icon',{staticStyle:{"color":"var(--topMenuFont)","vertical-align":"sub","cursor":"auto"},attrs:{"icon":"clock"}}),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.time))]),_c('span',[_vm._v(_vm._s(_vm.date))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }